import { GENERAL_ERRAND_STATUS } from '@/app/errand-configurations/general-errands/handle/[id]/constants';
import { INSPECTION_ERRAND_STATUS } from '@/app/errand-configurations/inspections/constants';
import { ROUNDING_OCCURRENCE_STATUS } from '@/app/errand-configurations/rounds/constants';

export const GENERAL_ERRAND_ACCEPTED_STATUSES = [
  GENERAL_ERRAND_STATUS.ACCEPTED,
  GENERAL_ERRAND_STATUS.STARTED,
] as const;

export const GENERAL_ERRAND_COMPLETED_STATUSES = [
  GENERAL_ERRAND_STATUS.ANNULLED,
  GENERAL_ERRAND_STATUS.COMPLETED,
  GENERAL_ERRAND_STATUS.COMPLETED_REPORTER,
] as const;

export const INSPECTION_ERRAND_ACCEPTED_STATUSES = [
  INSPECTION_ERRAND_STATUS.ACCEPTED,
  INSPECTION_ERRAND_STATUS.STARTED,
] as const;

export const INSPECTION_ERRAND_COMPLETED_STATUSES = [
  INSPECTION_ERRAND_STATUS.ANNULLED,
  INSPECTION_ERRAND_STATUS.COMPLETED,
] as const;

export const GENERAL_ERRAND_ACTIVE_STATUSES = [
  GENERAL_ERRAND_STATUS.CREATED,
  GENERAL_ERRAND_STATUS.ACCEPTED,
  GENERAL_ERRAND_STATUS.PAUSED,
  GENERAL_ERRAND_STATUS.STARTED
]

export const INSPECTION_ERRAND_ACTIVE_STATUSES = [
  INSPECTION_ERRAND_STATUS.CREATED,
  INSPECTION_ERRAND_STATUS.ACCEPTED,
  INSPECTION_ERRAND_STATUS.PAUSED,
  INSPECTION_ERRAND_STATUS.STARTED
]

export const ROUNDING_OCCURRENCE_ACTIVE_STATUSES = [
  ROUNDING_OCCURRENCE_STATUS.CREATED,
  ROUNDING_OCCURRENCE_STATUS.ACCEPTED,
  ROUNDING_OCCURRENCE_STATUS.PAUSED,
  ROUNDING_OCCURRENCE_STATUS.STARTED,
]